import styled from 'styled-components/macro';
import { indexes, sizes } from '../../../styles/variables';

export const Container = styled.div`
  align-items: center;
  background: rgba(157, 166, 186, 0.2);
  backdrop-filter: blur(5px);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: ${sizes.menuWidth};
  position: fixed;
  transition: opacity 300ms;
  top: 0;
  width: 100vw;
  z-index: ${indexes.backdrop};
`;
